import {
  BRANCH_ACCESS_DENIED_EVENT,
  useBranchStore,
} from '../store/branch.store';

/**
 * Recover from a `BRANCH_ACCESS_DENIED` 403: the selected branch is
 * outside the caller's access set (an admin revoked it mid-session, or
 * a stale persisted selection survived a login). Drops the branch from
 * the store — falling back to the first reachable branch — and tells the
 * branch selector to drop it from its cached list and refetch the set.
 *
 * Never retries the request. Safe to call once per failing request:
 * `revokeBranch` is idempotent, so a burst of concurrent 403s for the
 * same branch moves the selection exactly once.
 */
export const recoverFromBranchAccessDenied = (
  deniedBranchId: string | undefined
): void => {
  if (!deniedBranchId) return;
  useBranchStore.getState().revokeBranch(deniedBranchId);
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(BRANCH_ACCESS_DENIED_EVENT, { detail: deniedBranchId })
  );
};
